import axios from 'axios';

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://app.saasarg.com/api',
  comercio: process.env.REACT_APP_COMERCIO || 'station',
  tokenapi: process.env.REACT_APP_TOKEN_API || '04baf6d7da6deed19e0c00cfda4796c0'
};

const apiClient = axios.create({
  baseURL: API_CONFIG.baseURL,
  headers: {
    'Content-Type': 'application/json',
    'comercio': API_CONFIG.comercio,
    'tokenapi': API_CONFIG.tokenapi //  el token no lo enviamos por el momento
  }
});

// Interceptor para agregar token de cliente si existe
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token_access');
  if (token) {
    config.headers['tokenclient'] = token;
  }
  
  return config;
});

// Interceptor para manejar respuestas
apiClient.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error.response?.data || error);
  }
);

export default apiClient;

